import type { NormalizedApiError } from '../core/normalizedApiError';

/**
 * RFC 7807-style Problem JSON (optional `error_code` + `meta` per platform design).
 */
export interface ProblemDetailsJson {
  type?: string;
  title?: string;
  status?: number;
  detail?: string;
  instance?: string;
  error_code?: string;
  meta?: Record<string, unknown>;
}

export function parseProblemDetailsJson(data: unknown, httpStatus?: number): NormalizedApiError | null {
  if (!data || typeof data !== 'object') return null;
  const d = data as ProblemDetailsJson;
  if (typeof d.detail !== 'string' && typeof d.title !== 'string' && !d.error_code) return null;
  const message =
    (typeof d.detail === 'string' && d.detail.trim()) ||
    (typeof d.title === 'string' && d.title.trim()) ||
    'Something went wrong. Please try again.';
  return {
    httpStatus: httpStatus ?? d.status,
    errorCode: d.error_code,
    message: sanitize(message),
    title: typeof d.title === 'string' ? d.title : undefined,
    typeUri: typeof d.type === 'string' ? d.type : undefined,
    instance: typeof d.instance === 'string' ? d.instance : undefined,
    meta: d.meta,
    raw: data,
  };
}

function sanitize(s: string): string {
  const t = s.trim();
  if (!t) return 'Something went wrong. Please try again.';
  if (t.length > 500 || /traceback/i.test(t)) return 'Something went wrong. Please try again.';
  return t;
}
